import {
  createFileRoute,
} from '@tanstack/react-router'

import {
  PendingApprovalPage,
} from '@/features/payee/pages/pending-approval-page'

export const Route = createFileRoute(
  '/_authenticated/payee/pending-approval',
)({
  component: PendingApprovalPage,
})
